import React, { useContext, useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { EsubeApi, Platform } from "../../../services/authentication/api";
import { Configuration } from "../../../services/authentication/configuration";
import AuthContext from "../context";
import { useDispatch } from 'react-redux';
import { login } from "../../../stores/auth";
import JSEncrypt from 'jsencrypt';
import { WatchListAllSymbolsServiceApi } from "../../../services/actionHub/api";
import { APIControl } from "../../../helpers/APIControl";
import { setWatchlist } from "../../../stores/watchlist";
import { ProfileServiceApi } from "../../../services/profile/api";
import { Configuration as ProfileConfiguration } from "../../../services/profile/configuration";
import { setProfileBasicDetail } from "../../../stores/profileSlice";
import { setMainDefaultSecurity, setSelectedSecurity } from "../../../stores/security";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MetKey = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB3prLK5rWvXhOfC8JyMImg
NWH1XaY8+pQGs5FVy0dAPcogNi7FJKQvjNOx2nNl4ESU1ShT3TNe69L8x45MR2zg
OGbgN1NXdCCYu7bsJlQUxWuu1jEqZVl5PKgz8JSrkk47kRUFHw2Ogb50nYhR9X0q
LaU+UZshu5UG/ut/gaSS8TStrHwGifYsVRJIytSldEWlUWtuh19dc7RHVhwd3nd5
lBqqJC3cy2va2rRjC0f/UwHCANfvOPMT1Kfe+9ygihQ8l9B199+kgzy1Z/loBRsr
mVttnyKF9qvjzXbk5ZaFznyAFOu0pdLf3Wqp0X7YPFV7K2tqBoLJACUpH2NSUDej
AgMBAAE=
-----END PUBLIC KEY-----`;

const SMS_RESEND_SECONDS = 180;
const OTP_INFO_TEXT = "Lütfen Osmanlı Şifre uygulamasına gelen 6 haneli OTP onay kodunuzu giriniz.";
const SMS_INFO_TEXT = "Lütfen cep telefonunuza SMS olarak gelen 6 haneli onay kodunu giriniz.";

const TwoFactorVerification = () => {
    let contextVal = useContext(AuthContext);
    let dispatch = useDispatch();
    let navigate = useNavigate();
    let toast = useRef(null);
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(MetKey);
    const esubeApi = new EsubeApi(new Configuration({ basePath: process.env.REACT_APP_AUTHENTICATION_API_BASE_PATH }));
    const watchListAllSymbolsServiceApi = new WatchListAllSymbolsServiceApi(
        new Configuration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH)
    );
    const profileService = new ProfileServiceApi(
        new ProfileConfiguration({ basePath: process.env.REACT_APP_PROFILE_API_BASE_PATH }),
        undefined,
        APIControl(process.env.REACT_APP_PROFILE_API_BASE_PATH)
    );
    const { i18n } = useTranslation();

    let [verificationCode, setVerificationCode] = useState("");
    let [seconds, setSeconds] = useState(SMS_RESEND_SECONDS);
    let [isSMSForce, setIsSMSForce] = useState(false);
    let [isLoading, setIsLoading] = useState(false);

    const verificationCodeHandler = (event) => {
        event?.preventDefault();
        loginEsube();
    }

    const getErrorMessage = (err) => err?.response?.data?.Error || err?.message || "Beklenmeyen bir hata oluştu.";

    useEffect(() => {
        if (!isSMSForce || seconds <= 0) return undefined;

        const timer = setTimeout(() => {
            setSeconds((prevSeconds) => Math.max(prevSeconds - 1, 0));
        }, 1000);

        return () => clearTimeout(timer);
    }, [isSMSForce, seconds]);

    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const remainingSeconds = time % 60;
        const formattedTime = `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
        return formattedTime;
    };

    const handleVerificationCodeChange = (event) => {
        const nextValue = event.target.value.replace(/\D/g, "").slice(0, 6);
        setVerificationCode(nextValue);
    };

    //#region Post-login helpers (Sms Verification ekranıyla aynı akış)
    const getUserWatchlistData = (token) => {
        try {
            const culture = "tr-TR";
            watchListAllSymbolsServiceApi.actionhubWatchlistallsymbolsGet(token, culture).then((response) => {
                if (!response.data.error) {
                    let data = response.data.watchlist;
                    data = data.filter(element => !element.id.includes('xu030') && !element.id.includes('xu100'));
                    const favoritesSecuritiesData = data.flatMap(element =>
                        element.securitiesEntityIds.map(security => ({
                            ...security,
                            watchlistId: element.id,
                            watchlistName: element.name,
                        }))
                    );
                    dispatch(setWatchlist(favoritesSecuritiesData));
                } else {
                    console.error("getUserWatchlistData:", response.data.error);
                }
            });
        } catch (error) {
            console.error("getUserWatchlistData error:", error);
        }
    };

    const getProfileBasicDetail = async (token) => {
        try {
            await profileService.profileBasicprofiledetailGet(token).then((response) => {
                if (response.data.error != "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
                    return;
                }
                dispatch(setProfileBasicDetail(response.data.profile));
                i18n.changeLanguage(response.data.profile.languagecode);
            }).catch((error) => {
                console.log('getProfileBasicDetail', error);
            });
        } catch (error) {
            console.log('getProfile', error);
        }
    };

    const getDefaultSecurity = (token) => {
        try {
            profileService.profileFetchstockGet(token).then((response) => {
                if (response.data.error.length > 0) {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: response.data.error, life: 3000 });
                    return;
                }
                dispatch(setMainDefaultSecurity(response.data.securityCode));
                navigate("/StockAnalysis/summary/" + response.data.securityCode);
            }).catch((error) => {
                console.log('getDefaultSecurity', error);
                navigate("/StockAnalysis/summary/TUPRS");
            });
        } catch (error) {
            console.log('getDefaultSecurity', error);
            navigate("/StockAnalysis/summary/TUPRS");
        }
    };

    const completeLogin = (loginResultData) => {
        const userData = {
            customerNumber: contextVal?.authState.customerNumber,
            user: loginResultData,
            token: loginResultData.TokenId,
            accountId: loginResultData.AccountId,
            expireDate: loginResultData.ExpireDate,
            mfaTraceId: contextVal?.authState.userLoginInputs.mfaTraceId,
        };

        dispatch(login(userData));
        dispatch(setSelectedSecurity({
            "alternativeName": "",
            "code": "TUPRS",
            "Code": "TUPRS",
            "countryCode": "TR",
            "dataId": 368,
            "elite": false,
            "id": "sec.101.368",
            "index": false,
            "listed": true,
            "name": "TÜPRAŞ",
            "objectId": "sec.101.368",
            "screenable": true,
            "sourceId": 101,
            "uniqueCode": "TUPRS:IS",
            "visible": true
        }));

        getUserWatchlistData(loginResultData.TokenId);
        getProfileBasicDetail(loginResultData.TokenId);

        toast.current.show({ severity: "success", summary: "Başarılı", detail: "Giriş başarılı. Yönlendiriliyorsunuz...", life: 3000 });

        getDefaultSecurity(loginResultData.TokenId);
    };
    //#endregion

    //#region API CALLS

    const requestForceSms = ({ showSuccessToast = false } = {}) => {
        const customerNumber = parseInt(contextVal?.authState.userLoginInputs.customerNumber, 10);
        const encryptedPassword = encrypt.encrypt(contextVal?.authState.userLoginInputs.password);

        if (!customerNumber || Number.isNaN(customerNumber) || !encryptedPassword) {
            toast.current.show({ severity: "error", summary: "Hata", detail: "SMS gönderimi için kullanıcı bilgileri bulunamadı.", life: 3000 });
            return;
        }

        setIsLoading(true);

        esubeApi.apiEsubeLoginForceSmsPost(Platform.Web, { CustomerNumber: customerNumber, Password: encryptedPassword }).then((res) => {
            if (res.data?.Status === "Error" || !res.data?.Data) {
                toast.current.show({ severity: "error", summary: "Hata", detail: res.data?.Error || "SMS gönderilemedi. Lütfen tekrar deneyiniz.", life: 3000 });
                return;
            }
            const mfaTraceId = res.data.Data.MFATraceId || "";
            setIsSMSForce(true);
            setVerificationCode("");
            setSeconds(SMS_RESEND_SECONDS);
            contextVal.setAuthState({
                ...contextVal.authState,
                userLoginInputs: {
                    ...contextVal.authState.userLoginInputs,
                    mfaTraceId,
                },
            });

            if (showSuccessToast) {
                toast.current.show({ severity: "success", summary: "Başarılı", detail: "SMS doğrulama kodu tekrar gönderildi.", life: 3000 });
            }
        }).catch((err) => {
            toast.current.show({ severity: "error", summary: "Hata", detail: getErrorMessage(err), life: 3000 });
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const forceSMSBegin = () => {
        requestForceSms();
    }

    const resendCode = () => {
        if (!isSMSForce || seconds > 0 || isLoading) return;
        requestForceSms({ showSuccessToast: true });
    }

    const loginEsube = () => {
        if (!verificationCode || verificationCode.length !== 6) {
            toast.current.show({ severity: "error", summary: "Doğrulama Hatası", detail: "Doğrulama kodu 6 haneli rakamlardan oluşmalıdır", life: 3000 });
            return;
        }

        const mfaTraceId = contextVal?.authState.userLoginInputs.mfaTraceId;
        setIsLoading(true);

        const request = isSMSForce
            ? esubeApi.apiEsubeCompleteLoginForceSmsPost(verificationCode, mfaTraceId)
            : esubeApi.apiEsubeCompleteLoginPost(verificationCode, mfaTraceId);

        request.then((res) => {
            if (res.data?.Status === "Ok" && res.data?.Data) {
                completeLogin(res.data.Data);
            } else {
                toast.current.show({ severity: "error", summary: "Hata", detail: res.data?.Error || "Doğrulama kodu geçersiz.", life: 3000 });
            }
        }).catch((err) => {
            toast.current.show({ severity: "error", summary: "Hata", detail: getErrorMessage(err), life: 3000 });
        }).finally(() => {
            setIsLoading(false);
        });
    }
    //#endregion API CALLS


    return (
        <>
            <Toast ref={toast} position="bottom-right" />
            <Container className="verification">
                <Row className="verification-row">
                    <Col md="12">
                        <Row>
                            <div className="col-md-12 roboto-bold-34 color-text">
                                {isSMSForce ? "SMS ile Doğrulama" : "OTP ile Doğrulama"}
                            </div>
                        </Row>
                        <Row>
                            <label className="p-t-10 color-text-grey">
                                {isSMSForce ? SMS_INFO_TEXT : OTP_INFO_TEXT}
                            </label>
                        </Row>
                    </Col>

                    <Col md="12" className="input-col">
                        <form className="verification-form" onSubmit={verificationCodeHandler}>
                            <InputText
                                id={isSMSForce ? "sms-verification-code" : "otp-verification-code"}
                                className="verification-input"
                                placeholder="6 haneli kod"
                                value={verificationCode}
                                onChange={handleVerificationCodeChange}
                                maxLength={6}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                autoComplete="one-time-code"
                                disabled={isLoading}
                                autoFocus
                            />

                            {isSMSForce && (
                                <>
                                    <div className="verification-timer color-text">
                                        Kalan süre {formatTime(seconds)}
                                    </div>
                                    <button
                                        type="button"
                                        className="verification-resend-button"
                                        onClick={resendCode}
                                        disabled={seconds > 0 || isLoading}
                                    >
                                        Kodu Tekrar Gönder
                                    </button>
                                </>
                            )}

                            <Button slot="end" type="submit" variant="dark" className="loginBtn m-t-40" disabled={isLoading}>
                                {isLoading ? "İŞLENİYOR" : "DOĞRULA"}
                            </Button>

                            {!isSMSForce && (
                                <Button
                                    type="button"
                                    variant="outline-dark"
                                    className="verification-secondary-action"
                                    onClick={forceSMSBegin}
                                    disabled={isLoading}
                                >
                                    SMS Doğrulaması ile Devam Et
                                </Button>
                            )}
                        </form>
                    </Col>
                </Row >
            </Container >
        </>
    );
}

export default TwoFactorVerification;
